module.exports = __webpack_public_path__ + "static/media/homepage.969dbd0d.png";